import { httpRequest } from "services/build-request";

export const getPromoCodes = async ({ filters }) => {
  const route = `challenge-promo`;
  const { success, data } = await httpRequest({ route, params: filters });
  return { success, data };
};

export const updateInfoPromCode = async ({ newInfoPromeCode: { affiliateCodeId, ...rest } }) => {
  const route = `challenge-promo/${affiliateCodeId}`;
  const { success, data } = await httpRequest({
    route,
    method: "PUT",
    body: { justification: rest.justificacion, deliveredAt: rest.deliveredAt },
  });
  return { success, data };
};

export const getCounterChallengesCodes = async () => {
  const route = `challenge-promo/counter-challenges`;
  const { success, data } = await httpRequest({ route });
  return { success, data };
};
